import React from 'react';
interface PageHeroProps {
  title: string;
  subtitle?: string;
  label?: string;
  backgroundImage?: string;
}
export function PageHero({
  title,
  subtitle,
  label,
  backgroundImage
}: PageHeroProps) {
  return <section className="relative bg-navy-900 pt-40 pb-24 border-b border-white/5" data-id="element-292">
      {backgroundImage && <div className="absolute inset-0 z-0" data-id="element-293">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover" data-id="element-294" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy-900/85 to-navy-900/60" data-id="element-295" />
        </div>}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8" data-id="element-296">
        <div className="border-l-4 border-cg-orange-600 pl-6" data-id="element-297">
          {label && <span className="text-sm font-bold uppercase tracking-[0.2em] text-cg-orange-600 block mb-3" data-id="element-298">
              {label}
            </span>}
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight max-w-4xl" data-id="element-299">
            {title}
          </h1>
          {subtitle && <p className="text-lg text-steel-300 max-w-3xl leading-relaxed font-light" data-id="element-300">
              {subtitle}
            </p>}
        </div>
      </div>
    </section>;
}